<div class="content-recovery">
  <div class="recovery-form text-secondary">
    <form *ngIf="!isValidEmail" [formGroup]="formRecovery">
      <div *ngIf="valueRadio == '1'">
        <div class="mt-3 mb-2 text-medium">
          <p>Ingresa el correo electrónico asociado a tu cuenta</p>
        </div>
        <div>
          <input
            type="email"
            class="form-control"
            placeholder="Correo electrónico"
            formControlName="email"
          />

          <small
            *ngIf="f.email.hasError('required') && f.email.touched"
            class="text-danger ml-2"
          >
            Campo obligatorio *</small
          >
          <small
            *ngIf="f.email.hasError('pattern') && f.email.touched"
            class="text-danger ml-2"
          >
            Correo no válido</small
          >
        </div>

        <div class="button-top text-center">
          <app-button
            (click)="submit()"
            class="mt-1"
            [text]="'finalizar'"
            [class]="'btn-primary'"
          ></app-button>
        </div>
      </div>
      <div *ngIf="valueRadio == '3'">
        <div class="mb-3 text-medium">
          <p>
            Por favor restuare su <br />
            contraseña
          </p>
        </div>

        <div style="margin-bottom: 6px">
          <div class="input-icon">
            <div
              class="help-password"
              title="Su contraseña debe contener mínimo 8 caracteres"
            >
              <i class="fas fa-question-circle"></i>
            </div>
            <i
              *ngIf="!show"
              class="fas fa-eye-slash lock"
              (click)="switchPass()"
            ></i>
            <i *ngIf="show" class="fas fa-eye lock" (click)="switchPass()"></i>
            <input
              type="password"
              [type]="show ? 'text' : 'password'"
              class="form-control"
              placeholder="Nueva contraseña (*)"
              formControlName="password1"
            />
            <div *ngIf="f.password1.touched && f.password1.invalid">
              <small
                class="text-danger ml-2"
                *ngIf="f.password1.errors?.required"
              >
                Campo obligatorio *
              </small>

              <small
                class="text-danger ml-2"
                *ngIf="f.password1.hasError('minlength')"
              >
                Contraseña no válida *
              </small>
            </div>
          </div>
        </div>

        <div>
          <div class="input-icon">
            <i
              *ngIf="!show"
              class="fas fa-eye-slash lock"
              (click)="switchPass()"
            ></i>
            <i *ngIf="show" class="fas fa-eye lock" (click)="switchPass()"></i>
            <input
              type="password"
              [type]="show ? 'text' : 'password'"
              class="form-control"
              placeholder="Repita su contraseña (*)"
              formControlName="password2"
            />
            <div *ngIf="f.password2.touched && f.password2.invalid">
              <small
                class="text-danger ml-2"
                *ngIf="f.password2.errors?.required"
              >
                Campo obligatorio *
              </small>

              <small
                class="text-danger ml-2"
                *ngIf="f.password2.hasError('minlength')"
              >
                Contraseña no válida *
              </small>
            </div>
          </div>

          <small
            *ngIf="f.password2.hasError('mustMatch') && f.password2.touched"
            class="text-danger ml-2"
          >
            Las contraseñas deben coincidir</small
          >
        </div>

        <div class="button-top text-center">
          <button
            class="btn btn-primary mt-1"
            [class]="'btn-primary'"
            [disabled]="!formRecovery.valid"
            (click)="submit()"
          >
            Aceptar
          </button>
        </div>
      </div>
    </form>

    <div *ngIf="isValidEmail">
      <p class="text-medium">
        Si el correo electrónico <br />que ingresó es válido en nuestra
        <br />base de datos, recibirá un <br />correo electrónico para
        <br />ingresar su nueva contraseña
      </p>

      <div class="button-top text-center">
        <app-button
          class="mt-5"
          [text]="'Iniciar Sesión'"
          [class]="'btn-primary'"
          (click)="goToLogin()"
        ></app-button>
      </div>
    </div>
  </div>
</div>

<!-- MODALES -->

<div>
  <ngx-smart-modal
    #recovered
    identifier="recovered"
    [customClass]="'nsm-centered modal-lugares'"
    class="text-center"
    [closable]="false"
    [escapable]="false"
    [dismissable]="false"
  >
    <div>
      <div class="modal-icon">
        <i style="font-size: 44px" class="fas fa-check-circle text-primary"></i>
      </div>
      <div class="container-modal mb-5 mt-3 text-medium">
        <p style="text-align: center">
          La contraseña se ha restablecido <br />
          exitosamente. Ahora puede iniciar sesión
        </p>
      </div>
      <button (click)="closeModal()" class="btn btn-primary">FINALIZAR</button>
    </div>
  </ngx-smart-modal>
</div>
